<template>
  <div class="content-hub-pages flex-column row">
    <section class="parent-page-container text-center">
      <h1>
        {{ parentPage.name }}
      </h1>
      <p>
        {{ parentPage.short_description }}
      </p>
    </section>

    <!-- Loopar ut huvudkategorier -->
    <!-- Bryt ut till egen component? -->
    <section class="filter-page-container">
      <div v-if="props.parent[0].id == KNOWLEDGEHUB_ID">
        <span class="filter-name-all">
          All Categories
        </span>
      </div>
      <div v-for="category in categoryTags">
        <span @click="toggleFiltersDiv" class="filter-name">
          {{ category.category }}
        </span>
        <div class="hide filter-checkbox-list" :id="category.category" ref="filterDivs">
          <label name="" id="" v-for="(tag, index) in category.tags">
            <input :id="tag.id" :value="tag.name" @change="handleCheckbox" type="checkbox" ref="tags">
            {{ tag.name }}
          </label>
        </div>
      </div>
    </section> 
    
    <!-- Loopa ut valda filter/tags -->
    <section class="selected-filters">
      <div v-for="tags in selectedTags" class="lite-margin">
        <button class="tags"  @click="removeFilters" :id="tags.id" :value="tags.name">{{ tags.name }} X</button>
      </div>

      <div v-if="selectedTags.length" class="clear-all-filter">
        <button @click="clearFilter">Rensa filter</button>
      </div>
    </section>

    <!-- Loopa ut compontent som bygger upp kort -->
    <section class="page-container">
      <article v-for="page in filteredPages.slice(0, pagesToShow)" class="page">
        <ContentHubPageCards :page="page" />
      </article>
    </section>

    <section class="show-more" v-if="filteredPages.length - 1 > pagesToShow - 1">
      <button class="button" @click="handleShowMore">Show more</button>
    </section>

  </div>
</template>

  
<script setup>
  import { computed, ref, watch } from 'vue';
  import ContentHubPageCards from './ContentHubPageCard.vue'; 

  const props = defineProps({
    data: {
      required: true,
      type: Array,
    },
    parent: {
      required: true,
      type: Array,
    },
    amount: {
      required: true,
      type: String,
    }
  })
  
  const KNOWLEDGEHUB_ID = '128' 
  const PAGES_AMOUNT = Number(props.amount);
  const pagesToShow = ref(Number(props.amount));
  const parentPage = ref(props.parent[0])
  const allPages = ref([]);
  const selectedTags = ref([])
  const tags = ref([])
  const filterDivs = ref([])
  const filteredPages = ref([])
  filteredPages.value = handlePropsData();

  const toggleFiltersDiv = (event) => {    
    filterDivs.value.forEach(div => {
      if (event.target.nextElementSibling.id == div.id && !event.target.classList.contains('active')) {
        div.classList.remove('hide')
        div.previousElementSibling.classList.add('active')
      } else {
        div.classList.add('hide')
        div.previousElementSibling.classList.remove('active')
      }
    })
  }

  const handleCheckbox = (event) => {
    const tagId = event.target.id
    if (event.target.checked) {
      selectedTags.value.push({
        name: event.target.value, 
        id: event.target.id
      })
    } else {
      const removedUnselected = selectedTags.value.filter((selected) => selected.id !== tagId)
      selectedTags.value = removedUnselected
    }
  }

  const removeFilters = (event) => {
    const tagId = event.target.id;
    tags.value.forEach(tag => {
      if (tag.id == tagId) {
        tag.checked = false;
      }
    })
    const removedUnselected = selectedTags.value.filter((selected) => selected.id !== tagId)
    selectedTags.value = removedUnselected
  }

  const clearFilter = () => {
    selectedTags.value = [];
    tags.value.forEach(tag => tag.checked = false)
  }

  function checkWhatParentPage() {
    if (props.parent[0].id == KNOWLEDGEHUB_ID) return props.data;
    else {
      return props.parent
    }
  }

  function handlePropsData() {
    let currentParent = checkWhatParentPage()
    let children = [];
    currentParent.map((category, index) => {
      if (!category.children.length) return;
      category.children.map(child => {
        children.push({
          parent: category,
          page: child
        })
      })
    });
    const sortedChildren = sortByDate(children)
    allPages.value = sortedChildren;
    return sortedChildren;    
  }

  function sortByDate(theArray) {
    let sortedArray = theArray.sort((a, b) => {
      const dateA = new Date(a.page.date);
      const dateB = new Date(b.page.date);
      return dateB - dateA;
    });
    return sortedArray
  }

  const handleShowMore = () => {
    pagesToShow.value = pagesToShow.value + PAGES_AMOUNT
  }

  const categoryTags = computed(() => {
    let currentParent = checkWhatParentPage()
    let catTags = [];
    currentParent.map((category, index) => {
      if (!category.children.length) return;
      const tempTagArray = [];
      category.children.map(child => {
        tempTagArray.push(...Object.values(child.tags))
        catTags[index] = {
          category: category.name,
          tags: [],
        }
      })
      catTags[index].tags.push(...tempTagArray)
      const filteredTags = [...new Map(catTags[index].tags.map(item => [item.id, item])).values()]
      catTags[index].tags = filteredTags;
    });
    // removes categories with no pages
    let filterEmpty = catTags.filter(element => Object.keys(element).length)
    // removes duplicates (bug?)
    let removeDuplicates = filterEmpty.filter((v,i,a)=>a.findIndex(v2=>(JSON.stringify(v) === JSON.stringify(v2)))===i)
    return removeDuplicates;
  })

  watch(selectedTags, (newTag, oldTag) => {
    const tagIdArray = selectedTags.value.map(tag => Number(tag.id));
    let filteredChildren = allPages.value.filter(entry => 
      Object.values(entry.page.tags).some(tag => tagIdArray.includes(tag.id))
    )
    if (!filteredChildren.length) {
      filteredPages.value = allPages.value;
      return
    }
    filteredPages.value = filteredChildren;
    pagesToShow.value = PAGES_AMOUNT;

  }, { deep: true })

</script>